(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dfc-system"] && !Shopify.designMode) return;
  try {
    (() => {
    const start = () => {
      if (!document.body.classList.contains('dfc-funnel')) return;
      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      document.querySelectorAll('[data-dfc-carousel]').forEach(carousel => {
        if (carousel.dataset.ready) return;
        carousel.dataset.ready = 'true';
        const track = carousel.querySelector('[data-dfc-track]');
        const slides = [...track.children];
        const prev = carousel.querySelector('[data-dfc-prev]');
        const next = carousel.querySelector('[data-dfc-next]');
        const dots = [...carousel.querySelectorAll('[data-dfc-dot]')];
        const status = carousel.querySelector('[data-dfc-position]');
        const index = () => slides.reduce((best, slide, i) => Math.abs(slide.offsetLeft - track.scrollLeft) < Math.abs(slides[best].offsetLeft - track.scrollLeft) ? i : best, 0);
        const update = () => {
          const current = index();
          if (status) status.textContent = `${current + 1} / ${slides.length}`;
          dots.forEach((dot,i) => dot.setAttribute('aria-current',String(i === current)));
          if (prev) prev.disabled = track.scrollLeft < 3;
          if (next) next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 3;
        };
        const go = i => track.scrollTo({left:slides[Math.max(0, Math.min(i,slides.length-1))].offsetLeft,behavior:reduced?'instant':'smooth'});
        prev?.addEventListener('click',() => go(index()-1));
        next?.addEventListener('click',() => go(index()+1));
        dots.forEach((dot,i) => dot.addEventListener('click',() => go(i)));
        track.addEventListener('scroll',update,{passive:true});
        track.addEventListener('keydown',e => {
          if(e.key==='ArrowRight'||e.key==='ArrowLeft'){ e.preventDefault();go(index()+(e.key==='ArrowRight'?1:-1)); }
        });
        track.tabIndex=0;
        new ResizeObserver(update).observe(track);
        update();
      });
      const sale = document.querySelector('[data-dfc-sale]');
      if (sale && !sale.dataset.ready) {
        sale.dataset.ready='true';
        const end=Date.parse(sale.dataset.end);
        const tick=()=>{
          const seconds=Math.max(0,Math.floor((end-Date.now())/1000));
          if(!Number.isFinite(seconds)||seconds===0){sale.hidden=true;return;}
          sale.querySelector('[data-dfc-countdown]').textContent=[Math.floor(seconds/3600),Math.floor(seconds/60)%60,seconds%60].map(n=>String(n).padStart(2,'0')).join(':');
        };
        tick();setInterval(tick,1000);
      }
      const dialog=document.getElementById('dfc-size-dialog');
      document.querySelectorAll('[data-dfc-size-open]').forEach(button=>{
        if(button.dataset.ready)return;button.dataset.ready='true';
        button.addEventListener('click',()=>dialog?.showModal());
      });
      if(dialog&&!dialog.dataset.ready){
        dialog.dataset.ready='true';
        dialog.querySelector('[data-dfc-size-close]')?.addEventListener('click',()=>dialog.close());
        dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
      }
      document.querySelectorAll('[data-dfc-load-more]').forEach(button=>{
        if(button.dataset.ready)return;button.dataset.ready='true';
        button.addEventListener('click',()=>{
          const feed=button.parentElement.querySelector('[data-dfc-feed]');
          const pending=[...feed.querySelectorAll('article[hidden]')];
          pending.slice(0,4).forEach(article=>article.hidden=false);
          const count=feed.querySelectorAll('article:not([hidden])').length;
          button.parentElement.querySelector('[data-dfc-feed-status]').textContent=`${count} reviews shown`;
          if(pending.length<=4){button.hidden=true;const revealed=pending[0];if(revealed){revealed.tabIndex=-1;revealed.focus({preventScroll:true});}}
        });
      });
      const productData=document.getElementById('dfc-product-data');
      if(!productData||productData.dataset.ready)return;
      productData.dataset.ready='true';
      const data=JSON.parse(productData.textContent);
      const money=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:data.currency||'USD'});
      const root=data.root.endsWith('/')?data.root:data.root+'/';
      const forms=[...document.querySelectorAll('form.dfc-buy')];
      let busy=false;
      const labels=new Map(forms.map(form=>[form,form.querySelector('[data-dfc-buy-button]').textContent]));
      const select=(id,updateUrl=true)=>{
        const variant=data.variants.find(v=>String(v.id)===String(id));
        if(!variant)return;
        forms.forEach(form=>{
          form.querySelectorAll('[data-dfc-size]').forEach(input=>input.checked=String(input.value)===String(id));
          form.querySelector('[data-dfc-buy-button]').disabled=!variant.available||busy;
          form.querySelector('.dfc-form-error').hidden=true;
        });
        document.querySelectorAll('[data-dfc-price]').forEach(el=>el.textContent=money.format(variant.price/100));
        document.querySelectorAll('[data-dfc-compare]').forEach(el=>{el.textContent=money.format(variant.compare_at_price/100);el.hidden=!(variant.compare_at_price>variant.price);});
        document.querySelectorAll('[data-dfc-saving]').forEach(el=>{
          const saving=(variant.compare_at_price-variant.price)/100;
          const formatted=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:data.currency||'USD',maximumFractionDigits:Number.isInteger(saving)?0:2,minimumFractionDigits:Number.isInteger(saving)?0:2}).format(saving);
          el.textContent=data.messages.save.replace('__AMOUNT__',formatted);el.hidden=saving<=0;
        });
        if(updateUrl){const url=new URL(location.href);url.searchParams.set('variant',id);history.replaceState(history.state,'',url);}
      };
      forms.forEach(form=>{
        form.addEventListener('change',event=>{if(event.target.matches('[data-dfc-size]'))select(event.target.value);});
        form.addEventListener('submit',async event=>{
          event.preventDefault();if(busy)return;
          const error=form.querySelector('.dfc-form-error');
          const selected=form.querySelector('[data-dfc-size]:checked');
          const variant=data.variants.find(v=>String(v.id)===selected?.value);
          if(!variant?.available){error.textContent=data.messages.select;error.hidden=false;return;}
          busy=true;forms.forEach(f=>f.querySelector('[data-dfc-buy-button]').disabled=true);
          const button=form.querySelector('[data-dfc-buy-button]');button.textContent=data.messages.loading;
          try{
            const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:variant.id,quantity:1}]}),credentials:'same-origin'});
            const result=await response.json();
            if(!response.ok)throw new Error(result.description||data.messages.error);
            location.assign(root+'checkout');
          }catch(e){busy=false;forms.forEach(f=>{const b=f.querySelector('[data-dfc-buy-button]');b.disabled=false;b.textContent=labels.get(f);});error.textContent=e.message||data.messages.error;error.hidden=false;}
        });
      });
      const restore=()=>{
        busy=false;forms.forEach(form=>form.querySelector('[data-dfc-buy-button]').textContent=labels.get(form));
        const id=new URL(location.href).searchParams.get('variant')||forms[0]?.querySelector('[data-dfc-size]:checked')?.value;
        if(id)select(id,false);
      };
      window.addEventListener('pageshow',restore);
      window.addEventListener('popstate',restore);
      restore();
    };
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
    document.addEventListener('shopify:section:load',start);
  })();
  } catch(e) { console.error(e); }
})();

})();
